import { gql } from "@apollo/client";

export const QUERY_VIRTUAL_GAPS = gql`
  query getVirtualGaps {
    getVirtualGaps
  }
`;

export const SUBSCRIBE_VIRTUAL_GAPS = gql`
  subscription virtualGapsUpdate {
    virtualGapsUpdate
  }
`;

export const MUTATE_REF_LAP_TIME = gql`
  mutation updateReferenceLapTime($lapTime: Float) {
    updateReferenceLapTime(lapTime: $lapTime)
  }
`;

export const MUTATE_PIT_STOP_LOSS = gql`
  mutation updatePitStopLoss($pitStopLoss: Float) {
    updatePitStopLoss(pitStopLoss: $pitStopLoss)
  }
`;
